/**
 * نوع الطبيب — the doctor's practitioner type, shared by the profile form and the
 * documents step (which asks for a different paper per type).
 *
 * Mirrors `DoctorType` on the API. `""` means "not chosen yet" in the form.
 */
export type DoctorType =
  | "specialist"
  | "practitioner"
  | "higher_diploma"
  | "";

/**
 * The doctor's type as the API reports it, with the pre-column fallback.
 *
 * `doctor_type` only started being stored in 2026-09. Older profiles have it null
 * and the type has to be read back from whichever professional id is filled —
 * which is what both screens used to do inline. That inference cannot produce
 * "higher_diploma", and does not need to: no profile saved before the column
 * existed could have chosen it.
 */
export const deriveDoctorType = (info: any): DoctorType => {
  if (info?.doctor_type) return info.doctor_type as DoctorType;
  if (info?.practition_id) return "practitioner";
  if (info?.specialization_id) return "specialist";
  return "";
};

/**
 * The types that pick from the specializations list (اختصاص). A higher diploma is
 * a qualification *in* a specialty, so it names one exactly like a specialist
 * does; the two differ only in the document required as evidence.
 */
export const usesSpecialization = (type: DoctorType): boolean =>
  type === "specialist" || type === "higher_diploma";
